export default "__VITE_ASSET__DtEK6f7E__"